"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variables = require("../common/variables.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _BackgroundColorContext = _interopRequireDefault(require("../BackgroundColorContext"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DxcSpinner = function DxcSpinner(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      value = _ref.value,
      _ref$showValue = _ref.showValue,
      showValue = _ref$showValue === void 0 ? false : _ref$showValue,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? "large" : _ref$mode,
      margin = _ref.margin;
  var colorsTheme = (0, _useTheme["default"])();
  var backgroundType = (0, _react.useContext)(_BackgroundColorContext["default"]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.spinner
  }, /*#__PURE__*/_react["default"].createElement(DXCSpinner, {
    margin: margin,
    mode: mode
  }, /*#__PURE__*/_react["default"].createElement(SpinnerContainer, {
    backgroundType: backgroundType,
    mode: mode
  }, mode === "overlay" && /*#__PURE__*/_react["default"].createElement(BackOverlay, null), /*#__PURE__*/_react["default"].createElement(BackgroundSpinner, {
    mode: mode
  }, mode !== "small" && /*#__PURE__*/_react["default"].createElement(SVGBackground, {
    viewBox: "0 0 140 140"
  }, /*#__PURE__*/_react["default"].createElement(CircleBackground, {
    cx: "70",
    cy: "70",
    r: "65",
    mode: mode
  })), mode === "small" && /*#__PURE__*/_react["default"].createElement(SVGBackground, {
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/_react["default"].createElement(CircleBackground, {
    cx: "8",
    cy: "8",
    r: "6",
    mode: mode
  }))), value >= 0 && value <= 100 ? /*#__PURE__*/_react["default"].createElement(Spinner, {
    role: "progressbar",
    mode: mode
  }, mode !== "small" && /*#__PURE__*/_react["default"].createElement(SVGSpinner, {
    viewBox: "0 0 140 140",
    isDeterminated: true
  }, /*#__PURE__*/_react["default"].createElement(CircleSpinner, {
    cx: "70",
    cy: "70",
    r: "65",
    backgroundType: backgroundType,
    mode: mode,
    isDeterminated: true,
    value: value
  })), mode === "small" && /*#__PURE__*/_react["default"].createElement(SVGSpinner, {
    viewBox: "0 0 16 16",
    isDeterminated: true
  }, /*#__PURE__*/_react["default"].createElement(CircleSpinner, {
    cx: "8",
    cy: "8",
    r: "6",
    backgroundType: backgroundType,
    mode: mode,
    isDeterminated: true,
    value: value
  }))) : /*#__PURE__*/_react["default"].createElement(Spinner, {
    role: "progressbar",
    mode: mode
  }, mode !== "small" && /*#__PURE__*/_react["default"].createElement(SVGSpinner, {
    viewBox: "0 0 140 140",
    isDeterminated: false
  }, /*#__PURE__*/_react["default"].createElement(CircleSpinner, {
    cx: "70",
    cy: "70",
    r: "65",
    backgroundType: backgroundType,
    mode: mode,
    isDeterminated: false
  })), mode === "small" && /*#__PURE__*/_react["default"].createElement(SVGSpinner, {
    viewBox: "0 0 16 16",
    isDeterminated: false
  }, /*#__PURE__*/_react["default"].createElement(CircleSpinner, {
    cx: "8",
    cy: "8",
    r: "6",
    backgroundType: backgroundType,
    mode: mode,
    isDeterminated: false
  }))), mode !== "small" && /*#__PURE__*/_react["default"].createElement(LabelsContainer, {
    label: label,
    value: value,
    showValue: showValue
  }, /*#__PURE__*/_react["default"].createElement(SpinnerLabel, {
    backgroundType: backgroundType,
    mode: mode
  }, label), (value || value === 0) && showValue && /*#__PURE__*/_react["default"].createElement(SpinnerProgress, {
    backgroundType: backgroundType,
    mode: mode,
    showValue: showValue
  }, value, "%")))));
};

var determinatedValue = function determinatedValue(props, strokeDashArray) {
  var val = 0;

  if (props.value >= 0 && props.value <= 100) {
    val = strokeDashArray * (1 - props.value / 100);
  }

  return val;
};

var DXCSpinner = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  height: ", ";\n  width: ", ";\n  display: ", ";\n  position: ", ";\n  top: ", ";\n  left: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n  z-index: ", ";\n\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n"])), function (props) {
  return props.mode === "overlay" ? "100vh" : "";
}, function (props) {
  return props.mode === "overlay" ? "100vw" : "";
}, function (props) {
  return props.mode === "overlay" ? "flex" : "";
}, function (props) {
  return props.mode === "overlay" ? "fixed" : "";
}, function (props) {
  return props.mode === "overlay" ? 0 : "";
}, function (props) {
  return props.mode === "overlay" ? 0 : "";
}, function (props) {
  return props.mode === "overlay" ? "center" : "";
}, function (props) {
  return props.mode === "overlay" ? "center" : "";
}, function (props) {
  return props.mode === "overlay" ? 1300 : "";
}, function (props) {
  return props.mode != "overlay" ? props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px" : "";
}, function (props) {
  return props.mode != "overlay" ? props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.top ? _variables.spaces[props.margin.top] : "" : "";
}, function (props) {
  return props.mode != "overlay" ? props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.right ? _variables.spaces[props.margin.right] : "" : "";
}, function (props) {
  return props.mode != "overlay" ? props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.bottom ? _variables.spaces[props.margin.bottom] : "" : "";
}, function (props) {
  return props.mode != "overlay" ? props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.left ? _variables.spaces[props.margin.left] : "" : "";
});

var SpinnerContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  align-items: center;\n  display: flex;\n  height: ", ";\n  width: ", ";\n  justify-content: center;\n  position: relative;\n  background-color: transparent;\n\n  @keyframes spinner-svg {\n    0% {\n      transform: rotateZ(0deg);\n    }\n    100% {\n      transform: rotateZ(360deg);\n    }\n  }\n  @keyframes svg-circle-large {\n    0% {\n      stroke-dashoffset: 400;\n      transform: rotate(0);\n    }\n\n    50% {\n      stroke-dashoffset: 75;\n      transform: rotate(45deg);\n    }\n\n    100% {\n      stroke-dashoffset: 400;\n      transform: rotate(360deg);\n    }\n  }\n  @keyframes svg-circle-small {\n    0% {\n      stroke-dashoffset: 35;\n      transform: rotate(0);\n    }\n\n    50% {\n      stroke-dashoffset: 8;\n      transform: rotate(45deg);\n    }\n\n    100% {\n      stroke-dashoffset: 35;\n      transform: rotate(360deg);\n    }\n  }\n"])), function (props) {
  return props.mode === "small" ? "16px" : "140px";
}, function (props) {
  return props.mode === "small" ? "16px" : "140px";
});

var BackOverlay = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 100vw;\n  height: 100vh;\n  opacity: 1;\n  transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: ", ";\n  opacity: ", ";\n"])), function (props) {
  return "".concat(props.theme.overlayBackgroundColor);
}, function (props) {
  return "".concat(props.theme.overlayOpacity);
});

var BackgroundSpinner = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  height: inherit;\n  width: inherit;\n  position: absolute;\n  z-index: 1;\n"])));

var SVGBackground = _styledComponents["default"].svg(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  height: inherit;\n  width: inherit;\n"])));

var CircleBackground = _styledComponents["default"].circle(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  animation: none;\n  fill: transparent;\n  stroke: ", ";\n  stroke-dasharray: ", ";\n  stroke-linecap: initial;\n  stroke-width: ", ";\n  transform-origin: 50% 50%;\n  vector-effect: non-scaling-stroke;\n"])), function (props) {
  return "".concat(props.theme.totalCircleColor);
}, function (props) {
  return props.mode !== "small" ? "409" : "38";
}, function (props) {
  return props.mode !== "small" ? "8.5px" : "2px";
});

var Spinner = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  height: inherit;\n  width: inherit;\n  position: relative;\n  z-index: 2;\n"])));

var SVGSpinner = _styledComponents["default"].svg(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  height: inherit;\n  width: inherit;\n  transform: rotate(-90deg);\n  top: 0;\n  left: 0;\n  transform-origin: center;\n  overflow: visible;\n  animation: ", ";\n"])), function (props) {
  return !props.isDeterminated ? "1.4s linear infinite both spinner-svg" : "";
});

var CircleSpinner = _styledComponents["default"].circle(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  fill: transparent;\n  stroke-linecap: initial;\n  vector-effect: non-scaling-stroke;\n  animation: ", ";\n  stroke: ", ";\n  transform-origin: ", ";\n  stroke-dasharray: ", ";\n  stroke-width: ", ";\n  stroke-dashoffset: ", ";\n"])), function (props) {
  return props.isDeterminated ? "none" : props.mode !== "small" ? "1.4s ease-in-out infinite both svg-circle-large" : "1.4s ease-in-out infinite both svg-circle-small";
}, function (props) {
  return props.backgroundType === "dark" || props.mode === "overlay" ? props.theme.trackCircleColorOverlay : props.theme.trackCircleColor;
}, function (props) {
  return !props.isDeterminated ? "50% 50%" : "";
}, function (props) {
  return props.mode !== "small" ? "409" : "38";
}, function (props) {
  return props.mode !== "small" ? "8.5px" : "2px";
}, function (props) {
  return props.isDeterminated ? props.mode !== "small" ? determinatedValue(props, 409) : determinatedValue(props, 38) : "";
});

var LabelsContainer = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  display: block;\n  margin: 0 auto;\n  position: absolute;\n  text-align: center;\n  width: 110px;\n"])));

var SpinnerLabel = _styledComponents["default"].p(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  margin: 0;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  color: ", ";\n  text-align: ", ";\n  letter-spacing: ", ";\n"])), function (props) {
  return props.mode === "overlay" ? props.theme.overlayLabelFontFamily : props.theme.labelFontFamily;
}, function (props) {
  return props.mode === "overlay" ? props.theme.overlayLabelFontWeight : props.theme.labelFontWeight;
}, function (props) {
  return props.mode === "overlay" ? props.theme.overlayLabelFontSize : props.theme.labelFontSize;
}, function (props) {
  return props.mode === "overlay" ? props.theme.overlayLabelFontStyle : props.theme.labelFontStyle;
}, function (props) {
  return props.mode === "overlay" ? props.theme.overlayLabelFontColor : props.backgroundType === "dark" ? props.theme.labelFontColorOnDark : props.theme.labelFontColor;
}, function (props) {
  return props.mode === "overlay" ? props.theme.overlayLabelTextAlign : props.theme.labelTextAlign;
}, function (props) {
  return props.mode === "overlay" ? props.theme.overlayLabelLetterSpacing : props.theme.labelLetterSpacing;
});

var SpinnerProgress = _styledComponents["default"].p(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n  margin: 0;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  color: ", ";\n  text-align: ", ";\n  letter-spacing: ", ";\n"])), function (props) {
  return props.value !== "" && props.showValue === true && "block" || "none";
}, function (props) {
  return props.mode === "overlay" ? props.theme.overlayProgressValueFontFamily : props.theme.progressValueFontFamily;
}, function (props) {
  return props.mode === "overlay" ? props.theme.overlayProgressValueFontWeight : props.theme.progressValueFontWeight;
}, function (props) {
  return props.mode === "overlay" ? props.theme.overlayProgressValueFontSize : props.theme.progressValueFontSize;
}, function (props) {
  return props.mode === "overlay" ? props.theme.overlayProgressValueFontStyle : props.theme.progressValueFontStyle;
}, function (props) {
  return props.mode === "overlay" ? props.theme.overlayProgressValueFontColor : props.backgroundType === "dark" ? props.theme.progressValueFontColorOnDark : props.theme.progressValueFontColor;
}, function (props) {
  return props.mode === "overlay" ? props.theme.overlayProgressValueTextAlign : props.theme.progressValueTextAlign;
}, function (props) {
  return props.mode === "overlay" ? props.theme.overlayProgressValueLetterSpacing : props.theme.progressValueLetterSpacing;
});

var _default = DxcSpinner;
exports["default"] = _default;